import React from 'react'

const EtUpdateCoachUserPad = () => {
  return (
    <div>EtUpdateCoachUserPad</div>
  )
}

export default EtUpdateCoachUserPad